export var WireType = /*#__PURE__*/function (WireType) {
  WireType[WireType["Invalid"] = -1] = "Invalid";
  WireType[WireType["Varint"] = 0] = "Varint";
  WireType[WireType["Bit64"] = 1] = "Bit64";
  WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
  WireType[WireType["StartGroup"] = 3] = "StartGroup";
  WireType[WireType["EndGroup"] = 4] = "EndGroup";
  WireType[WireType["Bit32"] = 5] = "Bit32";
  return WireType;
}(WireType || {});
export var PBType = /*#__PURE__*/function (PBType) {
  PBType[PBType["DOUBLE"] = 1] = "DOUBLE";
  PBType[PBType["FLOAT"] = 2] = "FLOAT";
  PBType[PBType["INT64"] = 3] = "INT64";
  PBType[PBType["UINT64"] = 4] = "UINT64";
  PBType[PBType["INT32"] = 5] = "INT32";
  PBType[PBType["FIXED64"] = 6] = "FIXED64";
  PBType[PBType["FIXED32"] = 7] = "FIXED32";
  PBType[PBType["BOOL"] = 8] = "BOOL";
  PBType[PBType["STRING"] = 9] = "STRING";
  PBType[PBType["GROUP"] = 10] = "GROUP";
  PBType[PBType["MESSAGE"] = 11] = "MESSAGE";
  PBType[PBType["BYTES"] = 12] = "BYTES";
  PBType[PBType["UINT32"] = 13] = "UINT32";
  PBType[PBType["ENUM"] = 14] = "ENUM";
  PBType[PBType["SFIXED32"] = 15] = "SFIXED32";
  PBType[PBType["SFIXED64"] = 16] = "SFIXED64";
  PBType[PBType["SINT32"] = 17] = "SINT32";
  PBType[PBType["SINT64"] = 18] = "SINT64";
  return PBType;
}(PBType || {});
export const wireTypes = [WireType.Invalid, WireType.Bit64, WireType.Bit32, WireType.Varint, WireType.Varint, WireType.Varint, WireType.Bit64, WireType.Bit32, WireType.Varint, WireType.LengthDelimited, WireType.Invalid, WireType.LengthDelimited, WireType.LengthDelimited, WireType.Varint, WireType.Varint, WireType.Bit32, WireType.Bit64, WireType.Varint, WireType.Varint];
// repeated fields are packed with WireType.LengthDelimited
export function isPacked(t) {
  return (t - 1 & 0xc) != 0x8;
}
export function NewFields(t) {
  return new Map(t);
}
export function NewMethods(t) {
  return new Map(t);
}
export function zero(f) {
  if (f.repeated) return [];
  switch (f.type) {
    case PBType.STRING:
      return '';
    case PBType.ENUM:
    case PBType.MESSAGE:
      return undefined;
    case PBType.BYTES:
      return new Uint8Array(0);
    case PBType.BOOL:
      return false;
    case PBType.DOUBLE:
    case PBType.FLOAT:
      return 0.0;
    case PBType.INT64:
    case PBType.UINT64:
    case PBType.INT32:
    case PBType.FIXED64:
    case PBType.FIXED32:
    case PBType.SFIXED32:
    case PBType.SFIXED64:
    case PBType.SINT32:
    case PBType.SINT64:
    case PBType.UINT32:
      return 0;
  }
  return undefined;
}
export function isZero(f, v) {
  return !v || !(f.repeated && Array.isArray(v) && v.length > 0 || f.oneof && (v === null || v === void 0 ? void 0 : v.oneofKind) !== undefined || f.type === PBType.MESSAGE && !(Object.keys(v).length === 0 && v.constructor === Object) || v !== zero(f));
}
